import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "published-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 7.24829C11.7868 7.24829 11.5943 7.33729 11.4577 7.48017L8.46869 10.4692C8.1758 10.7621 8.1758 11.237 8.46869 11.5299C8.76159 11.8228 9.23646 11.8228 9.52935 11.5299L11.25 9.80923V16.0016C11.25 16.4158 11.5858 16.7516 12 16.7516C12.4142 16.7516 12.75 16.4158 12.75 16.0016V9.80868L14.4712 11.5299C14.7641 11.8228 15.239 11.8228 15.5319 11.5299C15.8247 11.237 15.8247 10.7621 15.5319 10.4692L12.5306 7.46796C12.4299 7.36727 12.3077 7.30119 12.1788 7.26973C12.1436 7.26116 12.108 7.25515 12.0722 7.25172C12.0482 7.24943 12.0241 7.24828 12 7.24829Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18.8943 18.8943C22.7019 15.0867 22.7019 8.91332 18.8943 5.10571C15.0867 1.2981 8.91332 1.2981 5.10571 5.10571C1.2981 8.9133 1.2981 15.0867 5.10571 18.8943C8.9133 22.7019 15.0867 22.7019 18.8943 18.8943ZM6.16637 6.16637C9.3882 2.94454 14.6118 2.94454 17.8336 6.16637C21.0551 9.38823 21.0553 14.6119 17.8336 17.8336C14.6118 21.0554 9.38818 21.0554 6.16637 17.8336C2.94454 14.6118 2.94455 9.38818 6.16637 6.16637Z"
    }, null, -1)
  ])))
}
export default { render: render }